import {Slider, Slide} from './components';

function App() {
  return <section className="section-center">
    <Slider />
    {/* <Slide /> */}
  </section>;
}

export default App;
